module.exports = __webpack_public_path__ + "img/training-blue.801ecc01.png";